import Guard from '@/services/middleware'

const Home = () => import('@/views/dash/settings/satisfactionSurvey/Home.vue')
const ManagerHome = () => import('@/views/dash/settings/satisfactionSurvey/ManagerHome.vue')
const ManagerSatisfaction = () => import('@/views/dash/settings/satisfactionSurvey/ManagerSatisfaction.vue')
const ManagerInformation = () => import('@/views/dash/settings/satisfactionSurvey/ManagerInformation.vue')
const ControllerReplysSatisfaction = () => import('@/views/dash/settings/satisfactionSurvey/ControllerReplysSatisfaction.vue')
export default [

    {
        path: '/pesquisa-satisfacao',
        name: 'satisfaction.home',
        component: Home,
        meta: { title: 'Pesquisa de satisfação', permission: 2, module: 'mod_satisfaction_survey' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/pesquisa-satisfacao/:id',
        name: 'satisfaction.manager',
        component: ManagerHome,
        meta: { title: 'Gerenciar pesquisa de satisfação', permission: 2, module: 'mod_satisfaction_survey' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
        children: [
            {
                path: '',
                name: 'satisfaction.manager.home',
                component: ManagerSatisfaction,
                meta: { title: 'Gerenciar pesquisa de satisfação', permission: 2, middleware: 'mod_satisfaction_survey' },

            },
            {
                path: 'respostas',
                name: 'satisfaction.manager.information',
                component: ManagerInformation,
                meta: {title: 'Respostas da pesquisa de satisfação', permission: 2, middleware: 'mod_satisfaction_survey'},
            },
        ],
    },
    {
        path: '/pesquisa-satisfacao/controller',

        name: 'satisfaction.controller',
        component: ControllerReplysSatisfaction,
        meta: { title: 'Controller: Pesquisa de satisfação', permission: 2, module: 'mod_satisfaction_survey' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],

    },
]
